<template>
  <reply-memo></reply-memo>
</template>

<script>
import ReplyMemo from '../components/reply-memos/index';

export default { components: { ReplyMemo } };
</script>
